export function isValidEmail(email: string): boolean {
    /*
     * Validates whether the given string is in a valid email format.
     * The regex ensures:
     *    - The local part contains letters, digits, underscores, dots, or hyphens
     *    - An "@" symbol separates the local part and the domain
     *    - The domain contains one or more segments of letters, digits, or hyphens followed by a dot
     *    - Ends with a top-level domain of at least two alphabetic characters
     */
    return /^[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/.test(email);
}
